import { Col, Row } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import List from 'app/components/Core/Document/List'
import { RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

const Documents: React.FC<MemberProps<IRental>> = ({ member: rental }) => {
  const { tAttribute, tComponent } = ToolBox.useString()
  const { lastQuote, confirmationSnapshot, project } = rental
  const [documents, setDocuments] = useState<{ title: string; url: string }[]>([])

  const translate = (attribute: string) =>
    tAttribute({
      recordType: RecordType.rental,
      attribute
    })

  useEffect(() => {
    setDocuments(
      [
        confirmationSnapshot &&
          confirmationSnapshot.url && {
            title: translate('confirmation_document_link'),
            url: confirmationSnapshot.url
          },
        lastQuote &&
          lastQuote.url && {
            title: translate('quote_document_link'),
            url: lastQuote.url
          }
      ].filter(Boolean)
    )
  }, [rental])

  return (
    <List
      documents={documents}
      footer={
        <Row justify="center">
          <Col>
            <Link to={Routes.Project.member(project?.id).document}>
              {tComponent({
                componentName: 'documents',
                componentType: 'core',
                recordType: RecordType.rental,
                id: 'show_more'
              })}
            </Link>
          </Col>
        </Row>
      }
    />
  )
}

export default Documents
